export default {
  closeAll: "Close all",
  comment: "Comment",
  edit: "Edit",
  expandAll: "Expand all",
  howDoYouRateThisService: "How do you rate this service",
  imDissatisfied: "I am dissatisfied",
  imSatisfied: "I am satisfied",
  knowWhatYouThink: "We want to know what you think",
  loading: "Loading...",
  neutral: "Neutral",
  next: "Next",
  no: "No",
  openedIn: "Opened in",
  owner: "Owner",
  pageNotFound: "Page not found",
  ratingOf: "{{name}}'s review on 4/19",
  requester: "Requester",
  satisfied: "Satisfied",
  saveComment: "Save comment",
  send: "Send",
  service: "Service",
  thanks: "Thanks so much",
  ticketSummary: "Ticket summary",
  unsatisfied: "Unsatisfied",
  verySatisfied: "Very satisfied",
  veryUnsatisfied: "Very unsatisfied",
  withYourFeedbackWeCanImproveRelationship:
    "With your feedback we can always improve our relationship",
  yes: "Yes",
  yourOpinionWorthALot: "Your opinion is worth a lot to us",
  yourRatingHasAlreadyBeenSaved:
    "Your evaluation for our service has already been saved."
};
